import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import * as R from 'ramda';

import { PosPlugin } from 'plugins/plugin';

import { getTagsSlice } from '../../redux';

interface ErplyApiRequest {
  requestName: string;
  [key: string]: any;
}

interface SaveSalesDocumentRequest {
  requestName: 'saveSalesDocument';
  [key: string]: any;
}

function isSaveSalesDocumentRequest(
  request: ErplyApiRequest,
): request is SaveSalesDocumentRequest {
  return request.requestName === 'saveSalesDocument';
}

// Adds rowJDoc# to the saveSales request for each row that had return tags applied
function addReturnTagsDataToRequest(
  request: SaveSalesDocumentRequest,
  tags: { [key: string]: string[] },
) {
  Object.entries(tags).forEach(([orderIndex, tag]) => {
    let jdocObject;
    const existingJdoc: string | undefined = request[`rowJDoc${orderIndex}`];
    try {
      if (existingJdoc) {
        jdocObject = JSON.parse(existingJdoc);
      }
    } catch (error) {
      jdocObject = {};
    }
    jdocObject = R.assocPath(['BrazilPOS', 'returnTags'], tag, jdocObject);

    request[`rowJDoc${orderIndex}`] = JSON.stringify(jdocObject);
  });
  return request;
}

export const saveReturnTags: Required<
  PosPlugin
>['onSaveSalesDocument']['on'] = (p, ap) => async (
  dispatch: ThunkDispatch<unknown, unknown, Action>,
  getState: () => unknown,
) => {
  const tagsSlice = getTagsSlice()(getState());

  // No sales being saved - return as is
  if (!ap.find(isSaveSalesDocumentRequest)) {
    return ap;
  }
  // No tags applied - return as is
  if (!Object.keys(tagsSlice).length) {
    return ap;
  }
  const returnAp = ap.map(request => {
    if (!isSaveSalesDocumentRequest(request)) {
      return request;
    }
    return addReturnTagsDataToRequest(request, tagsSlice);
  });
  return returnAp;
};
